var _circle, _g, _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6, _rect7, _rect8, _rect9, _rect10, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconReminder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 500,
    viewBox: "0 0 528 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10898_26140",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 500,
    height: 500
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10898_26140)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.076 267.665C110.498 267.665 86.1564 271.051 75.0579 272.744L128.669 323.534C171.935 312.435 258 290.602 214 280C167.161 268.713 129.798 267.665 119.076 267.665Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.446 271.642C84.8365 271.622 85.0429 271.615 85.0429 271.615L84.6828 272.314C86.3679 276.758 97.4875 301.035 140.537 305.037C187.973 309.446 207.582 278.361 207.582 278.361C207.582 278.361 236.5 282.5 248.5 288.5C273.581 312.327 304.604 349.784 327.067 376.906C331.472 382.225 335.548 387.147 339.185 391.49C367.402 373.431 406.884 353.443 406.884 353.443L440.18 362.473C440.18 362.473 430.999 381.336 406.884 400.747C405.49 401.87 403.356 403.856 400.583 406.437C387.797 418.339 361.405 442.906 331 454C301 438.5 274.5 416 253 375.5C248.5 416 262.775 576.778 264.673 580.869C269.24 590.756 278.217 606.238 278.217 606.238C278.217 606.238 108.844 692.485 58.0497 670.374C55.6815 669.35 52.2017 663.827 52.2017 663.827L52.6716 566.769C-58.69 468.994 -28.1758 453.131 -28.1758 453.131C-29.7958 419.863 -1.78647 332.589 19.4912 299.441C21.8241 295.807 24.7698 292.645 28.1137 289.896C28.7212 288.611 29.174 287.847 29.4142 287.653C32.7542 284.958 38.0304 282.587 44.0223 280.551C61.0464 273.339 79.7665 271.904 84.1087 271.66C84.3248 271.63 84.4378 271.615 84.4378 271.615C84.4378 271.615 84.4405 271.624 84.446 271.642Z",
    fill: "#2974B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.325 133.212C119.325 133.212 150.114 247.913 113.997 268.229C138.032 280.913 180.723 280.848 180.723 280.848L182.491 245.617C182.491 245.617 204.398 249.959 210.096 229.531C230.249 185.273 212.847 115.35 212.847 115.35L119.325 133.212Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.902 125.613C211.176 128.376 209.015 144.364 209.015 144.364L193.788 178.213C186.028 172.095 175.615 172.489 173.552 186.207C172.078 196.174 184.358 198.148 184.358 198.148C177.186 210.385 172.373 220.254 161.96 231.899C150.662 244.432 144.375 245.715 132.194 245.913H118.735C118.735 245.913 112.153 224.399 99.972 170.614C86.4153 110.909 156.655 118.606 169.72 103.408C190.94 78.6379 251.65 116.83 220.902 125.613Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.965 83.5724C222.965 83.5724 220.214 85.6449 215.695 87.816C206.756 91.9608 190.841 96.3031 174.239 86.0396C171.685 84.4606 169.131 83.375 166.577 82.7829C145.259 77.3551 125.022 101.83 122.861 104.593C119.619 108.047 116.869 111.896 114.707 116.139C106.554 119.791 99.6772 126.205 95.5512 134.199C88.8711 147.127 89.9517 168.542 101.347 176.24L112.939 172.391C113.725 173.871 114.707 175.253 115.886 176.437C116.77 177.325 118.047 178.115 119.226 178.509C120.798 179.003 122.468 178.904 123.647 177.917C124.924 176.832 125.415 175.055 125.71 173.279C126.103 171.404 126.496 169.529 126.889 167.654L209.801 139.923C209.604 142.094 209.015 144.265 208.229 146.041C208.229 146.041 208.229 146.041 208.327 146.041C208.72 146.041 210.489 146.14 212.945 145.647C218.151 144.66 226.796 141.502 233.574 131.14C244.086 115.35 241.433 91.4674 222.965 83.5724Z",
    fill: "#312C36"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 80,
    width: 223,
    height: 113.644,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 98,
    width: 136,
    height: 18,
    rx: 9,
    fill: "#40946A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 149.615,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 132,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 166.769,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.851 96L337.923 112.012L331.887 106.675L329 110.059L338.054 118L358 99.2544L354.851 96Z",
    fill: "#40946A",
    stroke: "#40946A",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 207,
    width: 223,
    height: 113.644,
    rx: 5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 371,
    y: 225,
    width: 136,
    height: 18,
    rx: 9,
    fill: "#9F9E8F"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 276.615,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 259,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 326.442,
    y: 293.769,
    width: 180.115,
    height: 6,
    rx: 3,
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M354.851 223L337.923 239.012L331.887 233.675L329 237.059L338.054 245L358 226.254L354.851 223Z",
    fill: "#787B7D",
    stroke: "#787B7D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.558 359.104C451.752 355.446 456.914 348.714 458.844 346.177C461.722 343.319 465.024 340.138 465.401 340.203C465.654 340.247 465.554 340.586 465.318 341.393L465.318 341.393C465.058 342.28 464.633 343.733 464.327 345.981C464.127 347.594 464.892 348.588 465.875 349.229C468.145 350.561 469.755 348.015 470.644 345.579C470.87 344.939 471.088 344.331 471.296 343.751L471.299 343.743L471.3 343.74C472.482 340.441 473.332 338.067 473.614 336.049C474.243 331.174 470.715 330.348 468.361 330.324C468.597 330.017 468.809 329.699 468.986 329.368C469.563 328.29 469.723 326.906 469.136 325.785C468.647 324.994 467.878 324.47 466.995 324.16C465.983 323.816 464.923 323.75 463.887 323.885C463.947 323.803 463.998 323.724 464.037 323.651C464.614 322.573 464.837 321.278 464.236 320.233C463.81 319.532 463.042 319.007 462.234 318.711C460.984 318.26 459.49 318.317 458.185 318.641C457.852 318.723 457.522 318.822 457.193 318.932C458.151 316.944 459.871 313.949 462.818 310.339C469.054 302.706 471.625 298.207 466.923 297.396C462.297 296.599 444.271 317.811 444.271 317.811C444.129 317.866 441.803 320.261 438.788 323.404C436.356 322.584 433.495 322.054 431.784 323.225C429.93 324.461 428.643 328.74 427.855 332.382L401.448 370.523L410.664 390.201L438.299 360.631C438.299 360.631 444.964 363.192 448.558 359.104Z",
    fill: "#D7AE88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407 353.5L377.5 377C386.5 384.333 405.5 398.4 409.5 396C413.5 393.6 431.5 373 440 363C437.6 358.2 417 354.667 407 353.5Z",
    fill: "#2974B2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReminder);
export default __webpack_public_path__ + "static/media/icon-reminder.3847806ad2cf38aa7c746a1fb5d8b02e.svg";
export { ForwardRef as ReactComponent };